import { BaseController } from "./_BaseController";
import { TypedMatNode } from "../_Base";
import { Material } from "three";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
import { isBooleanTrue } from "../../../../core/BooleanValue";
export function FogParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.useFog = ParamConfig.BOOLEAN(0);
    }
  };
}
class FogParamsConfig extends FogParamConfig(NodeParamsConfig) {
}
class FogMatNode extends TypedMatNode {
  createMaterial() {
    return new Material();
  }
}
export class FogController extends BaseController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  static update(node) {
    const material = node.material;
    const pv = node.pv;
    material.fog = isBooleanTrue(pv.useFog);
  }
}
